<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <form action="post" @submit.prevent="createCustomer()" :class="{ 'was-validated': submitted }">
      <div class="form-group">
        <label for="Name">Företag</label>
        <input type="text" class="form-control" id="Name" v-model="customer.Name" required>
      </div>

      <fieldset>
      <legend>Postadress</legend>
        <div class="form-group">
          <label for="Address">Adress</label>
          <input type="text" class="form-control" id="Address" v-model="customer.Address">
        </div>

        <div class="form-group">
          <label for="PostalCode">Postnr</label>
          <input type="text" class="form-control" id="PostalCode" v-model="customer.PostalCode">
        </div>

        <div class="form-group">
          <label for="City">Ort</label>
          <input type="text" class="form-control" id="City" v-model="customer.City">
        </div>

        <div class="form-group">
          <label for="Country">Land</label>
          <select class="form-control" id="Country" v-model="customer.CountryId" required>
            <option v-for="c in countries" :key="c.CountryId" :value="c.CountryId">{{ c.Country }}</option>
          </select>
        </div>
      </fieldset>
      <fieldset>
      <legend>Besöksadress</legend>
        <div class="form-group">
          <label for="Address">Adress</label>
          <input type="text" class="form-control" id="Address" v-model="customer.vAddress">
        </div>

        <div class="form-group">
          <label for="PostalCode">Postnr</label>
          <input type="text" class="form-control" id="PostalCode" v-model="customer.vPostalCode">
        </div>

        <div class="form-group">
          <label for="City">Ort</label>
          <input type="text" class="form-control" id="City" v-model="customer.vCity">
        </div>
      </fieldset>
      <fieldset>
      <legend>Kontaktinfo</legend>
        <div class="form-group">
          <label for="Phone">Telefon</label>
          <input type="tel" class="form-control" id="Phone" v-model="customer.Phone">
        </div>

        <div class="form-group">
          <label for="Email">E-post</label>
          <input type="email" class="form-control" id="Email" v-model="customer.Email">
        </div>

        <div class="form-group">
          <label for="Web">Hemsida</label>
          <input type="text" class="form-control" id="Web" v-model="customer.Web">
        </div>
      </fieldset>
      <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  data () {
    return {
      customer: {
        Name: '',
        Address: '',
        PostalCode: '',
        City: '',
        CountryId: '',
        vAddress: '',
        vPostalCode: '',
        vCity: '',
        Email: '',
        Phone: '',
        Web: ''
      },
      countries: {},
      submitted: false,
      error: ''
    }
  },

  created () {
    appService.getCountries()
    .then(c => this.countries = c)
  },

  methods: {
    createCustomer () {
      appService.createCustomer(this.customer)
      .then((inserted) => { this.$router.push(`/customers/${inserted.id}`) })
      .catch(() => { this.error = 'Det gick inte att spara.' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/CustomerAdd.vue